module.exports = __webpack_public_path__ + "media/images/austrian/qr/qr-code-ea11f617d39ceaedcced7d4b8242b2ad.png";